export default __webpack_public_path__ + "static/media/TopicTip_Personalization.fe915eea.svg";